export default "__VITE_ASSET__Be$FiUdc__"